(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["before-after-slider"] && !Shopify.designMode) return;
  try {
    class BeforeAfterSlider {
    constructor(frame) {
      this.frame = frame;
      this.range = frame.querySelector('[data-ba-range]');
      if (!this.range) return;

      this.onInput = this.onInput.bind(this);
      this.range.addEventListener('input', this.onInput);
      this.render(this.range.value);
    }

    onInput(event) {
      this.render(event.currentTarget.value);
    }

    render(value) {
      this.frame.style.setProperty('--ba-pos', `${value}%`);
    }
  }

  const initBeforeAfterSliders = (root) => {
    root.querySelectorAll('[data-ba-slider]').forEach((frame) => {
      if (frame.dataset.baInit === 'true') return;
      frame.dataset.baInit = 'true';
      new BeforeAfterSlider(frame);
    });
  };

  document.addEventListener('DOMContentLoaded', () => initBeforeAfterSliders(document));
  initBeforeAfterSliders(document);

  document.addEventListener('shopify:section:load', (event) => initBeforeAfterSliders(event.target));
  document.addEventListener('shopify:block:select', (event) => initBeforeAfterSliders(event.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dp-mobile-performance"] && !Shopify.designMode) return;
  try {
    (function () {
  function initMobileArtwork() {
    var menu = document.getElementById('mobile-menu');
    if (!menu || menu.dataset.dpArtworkBound === 'true') return;
    menu.dataset.dpArtworkBound = 'true';
    var observer;
    function hydrate() {
      menu.querySelectorAll('template[data-dp-menu-artwork]').forEach(function (template) {
        template.replaceWith(template.content.cloneNode(true));
      });
      if (observer) observer.disconnect();
      document.removeEventListener('click', onOpen, true);
    }
    function onOpen(event) {
      if (event.target instanceof Element && event.target.closest('[aria-controls="mobile-menu"]')) hydrate();
    }
    document.addEventListener('click', onOpen, true);
    observer = new MutationObserver(function () {
      if (menu.getAttribute('aria-hidden') === 'false') hydrate();
    });
    observer.observe(menu, {attributes: true, attributeFilter: ['aria-hidden']});
    if (menu.getAttribute('aria-hidden') === 'false') hydrate();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initMobileArtwork, {once: true});
  else initMobileArtwork();
  document.addEventListener('shopify:section:load', initMobileArtwork);
})();
  } catch(e) { console.error(e); }
})();

})();
